import { useState } from "react";
import { logEvent } from "../../utils/analytics";
import API from '../../utils/api.js';
import Input from './Input.jsx';
import Button from './Button.jsx';
import pvcImage from "../../assets/img/pvc-hero.svg";


const WhereToVoteForm = () => {

    const [pvcCode, setPVCCode] = useState();
    const [pollingUnit, setPollingUnit] = useState({});
    const [state, setState] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        findPollingUnit(pvcCode);
    }

    const findPollingUnit = (code) => {

        setState('loading');
        setError('');
        setPollingUnit({});

        API.findPollingUnit(code).then((res) => {

            setPollingUnit(res?.data?.data);
            logEvent('Where to Vote', 'Search polling unit code successful', code)
            setState('success');

            setTimeout(() => {
                setState("");
            })

        }).catch((err) => {
            logEvent('Where to Vote', 'Search polling unit code failed', code)
            setError('Pls make sure the code is valid and try again');
            setState('error');
        });
    };

    const formatPhoneNumber = (value) => {

        // Only allow digits
        const digitsOnly = value.replace(/\D/g, "")

        // Format with dashes: XX-XX-XX-XXXX
        let formatted = '';
        if (digitsOnly.length > 0) {
            if (digitsOnly.length <= 2) {
                formatted += digitsOnly
            } else if (digitsOnly.length <= 4) {
                formatted += digitsOnly.slice(0, 2) + "-" + digitsOnly.slice(2)
            } else if (digitsOnly.length <= 6) {
                formatted += digitsOnly.slice(0, 2) + "-" + digitsOnly.slice(2, 4) + "-" + digitsOnly.slice(4, 6)
            } else {
                formatted += digitsOnly.slice(0, 2) + "-" + digitsOnly.slice(2, 4) + "-" + digitsOnly.slice(4, 6) + "-" + digitsOnly.slice(6, 9)
            }
        }

        return formatted
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value
        const cursorPosition = e.target.selectionStart || 0

        const formattedNumber = formatPhoneNumber(inputValue)
        setPVCCode(formattedNumber);
        console.log(formattedNumber);

        if (formattedNumber.length === 12) {
            findPollingUnit(formattedNumber);
        }
        // Handle cursor positioning after formatting
        setTimeout(() => {
            const input = e.target
            if (input && cursorPosition) {
                // Calculate new cursor position based on formatting changes
                const digitsBeforeCursor = inputValue.slice(0, cursorPosition).replace(/\D/g, "").length

                let newPosition = 0
                let digitCount = 0

                for (let i = 0; i < formattedNumber.length && digitCount < digitsBeforeCursor; i++) {
                    if (/\d/.test(formattedNumber[i])) {
                        digitCount++
                    }
                    newPosition = i + 1
                }

                input.setSelectionRange(newPosition, newPosition)
            }
        }, 0)
    }

    const onGetDirectionsClick = () => {
        logEvent('Where to Vote', 'Clicked Get Directions Button', pollingUnit.code);
    }


    const getLinkToGetDirections = () => {
        const { longitude, latitude, polling_unit, ward, lga } = pollingUnit;
        const unitAddress = polling_unit?.substring(6) || '';
        const wardAddress = ward?.substring(5) || '';
        const lgaAddress = lga?.substring(5) || '';
        const query = (longitude && latitude) ? `${latitude},${longitude}` : `${unitAddress.toLowerCase()},${wardAddress.toLowerCase()},${lgaAddress.toLowerCase()}`
        return `https://www.google.com/maps?q=${query}`;
    };
    return <div className="flex md:flex-row flex-col gap-6 justify-between p-8">

        <div className="flex-1 space-y-6">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4 grow">
                <div className="flex flex-col gap-1">
                    <label className="text-neutral-600 center">
                        Enter your code here
                    </label>
                    <Input
                        bold={true}
                        loading={state === 'loading'}
                        disabled={state === 'loading'}
                        type="tel"
                        placeholder="30-06-03-004"
                        value={pvcCode}
                        onChange={handleInputChange}
                    />
                    {error && <p className="text-xs pl-1 text-red-600">{error}</p>}
                </div>

            </form>

            {pollingUnit.code && <article className="space-y-1">
                <h3 className="text-gray-900">Your polling unit is</h3>

                <ul className="space-y-1 pb-4">
                    <li className="">
                        <h6 className="text-xs text-gray-600">Address</h6>
                        <p className="leading-none font-semibold capitalize">{pollingUnit.polling_unit.toLowerCase()} </p>
                    </li>
                    <li className="">
                        <h6 className="text-xs text-gray-600">Ward</h6>
                        <p className="leading-none font-semibold capitalize">{pollingUnit.ward.toLowerCase()} </p>
                    </li>
                    <li className="">
                        <h6 className="text-xs text-gray-600">LGA</h6>
                        <p className="leading-none font-semibold capitalize">{pollingUnit.lga.toLowerCase()}</p>
                    </li>
                    <li className="">
                        <h6 className="text-xs text-gray-600">State</h6>
                        <p className="leading-none font-semibold capitalize">24 - Lagos</p>
                    </li>
                </ul>

                <a href={getLinkToGetDirections()} target="_blank" rel="noopener noreferrer">
                    <Button onClick={onGetDirectionsClick}>
                        Get Directions
                    </Button>
                </a>
            </article>}
        </div>


        <div className="md:max-w-[450px] flex-1 space-y-3 bg-gray-100  rounded p-4">
            <p className="text-center text-lg text-neutral-800">Instructions</p>
            <img className="opacity-95 w-[300px] rounded-lg" src={pvcImage} alt="" />
            <ul className="flex flex-col gap-1 text-neutral-700 list-decimal pl-5">
                <li className="text-sm">Look for the code on your Nigerian voter's card</li>
                <li className="text-sm">Enter only the numbers - dashes will be added automatically</li>
                <li className="text-sm">The format is: State-LG-Area-Polling Unit</li>
                <li className="text-sm">Example: 30-06-03-004</li>
            </ul>
        </div>
    </div>
}

export default WhereToVoteForm;
